import React from 'react';
import '../../styles/CategoryHeading.css';

const CategoryHeading = ({ title, description }) => {
  return (
    <div className="category-heading-container">
      <div className="category-heading-wrapper">
        <h1 className="category-heading">{title}</h1>
        {description && <h2>{description}</h2>}
      </div>
    </div>
  );
};

export default CategoryHeading;
